import React, { useEffect } from 'react';
import "../../CSS/Modal.css";
import { useSpring, animated } from 'react-spring'

const Modal = ({setShowModal, show, children}:{setShowModal:any, show:boolean, children:any}) => {

    const handleParentClick = () => {
        setShowModal();
    };

    const handleChildClick = (e:any) => {
        e.stopPropagation();
    }

    // Handle escape key to close modal
    useEffect(() => {
        const handleEscapeKey = (event: KeyboardEvent) => {
            if (event.key === 'Escape' && show) {
                setShowModal();
            }
        };

        if (show) {
            document.addEventListener('keydown', handleEscapeKey);
        }

        return () => {
            document.removeEventListener('keydown', handleEscapeKey);
        };
    }, [show, setShowModal]);

    const props = useSpring({
        config: { mass: 5, tension: 2000, friction: 200},
        from: { transform: 'scale(0)', opacity: '0' },
        to: { transform: 'scale(1)', opacity: '1' },
        reset: true,
    })

    return ( 
        show ? (
            <div className="Modal-background" onClick={handleParentClick}>
                <animated.div style={props} className="Modal-content" onClick={handleChildClick}>
                    {children}
                </animated.div>
            </div>
        ) : (
            null
        )
    )
}

export default Modal;